import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const OG_LOCALE_MAP: Record<string, string> = {
  en: 'en_US',
  ru: 'ru_RU',
  es: 'es_ES',
};

function setMeta(name: string, content: string) {
  const isOg = name.startsWith('og:');
  const attr = isOg ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.content = content;
}

export function useLocalizedMeta() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.title = t('meta.title');
    setMeta('description', t('meta.description'));
    setMeta('og:title', t('meta.og_title'));
    setMeta('og:description', t('meta.og_description'));
    setMeta('og:locale', OG_LOCALE_MAP[i18n.language] || 'en_US');
    setMeta('og:url', window.location.href);
    setMeta('og:type', 'website');
    setMeta('og:site_name', 'Peternity');
    setMeta('robots', 'max-snippet:-1, max-image-preview:large, max-video-preview:-1');
  }, [t, i18n.language]);
}
